module.exports = __webpack_public_path__ + "media/newstyle/images/alphagraphics-ae4002c8db1a403c3e7856237c096fc8.svg";